module.exports = __webpack_public_path__ + "img/文化部科技藝術實驗創新及輔導推動計畫.553697a2.png";